export var MoveDirection;
(function (MoveDirection) {
    MoveDirection[MoveDirection["Up"] = 0] = "Up";
    MoveDirection[MoveDirection["Down"] = 1] = "Down";
})(MoveDirection || (MoveDirection = {}));
export var PrivacyOption;
(function (PrivacyOption) {
    PrivacyOption["Private"] = "Private";
    PrivacyOption["Public"] = "Public";
})(PrivacyOption || (PrivacyOption = {}));
